import WeddingIcon from './WeddingIcon';
export default WeddingIcon;
